// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChartLine as RawChartLine } from "lucide-react";
export const ChartLine = /* @__PURE__ */ createIcon(RawChartLine, "ChartLine", 2);
